import { downloadDosageDiaryPDF } from '../service/downloadDosageDiaryPDF';
import { useState } from 'react';
import showToast from '../components/ToastComponent';
import saveAs from 'file-saver';
import { useAuth } from 'react-oidc-context';
import { ROLE } from '../interface/interface';

export function useToDownloadDosageDiaryPDF(token: string) {
  const [profileName, setProfileName] = useState<string | null>(null);
  const [previewBlob, setPreviewBlob] = useState<Blob | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>();
  const [activeButtonIndex, setActiveButtonIndex] = useState<string>();
  const auth = useAuth();

  async function handleDosageDiaryDownloadByProfile(
    dosageDiaryId: string,
    profileName: string,
  ) {
    setActiveButtonIndex(dosageDiaryId);
    const result = await downloadDosageDiaryPDF(token, dosageDiaryId);

    if (typeof result === 'number') {
      showToast({
        type: 'info',
        message: 'Unable to download PDF',
      });
      setActiveButtonIndex(undefined);
      return;
    }

    if (
      (auth?.user?.profile?.groups as string[] | undefined)?.includes(
        ROLE.Patients,
      )
    ) {
      const url = URL.createObjectURL(result);
      setPreviewBlob(result);
      setProfileName(profileName);
      setPreviewUrl(url);
      setActiveButtonIndex(undefined);
    } else {
      saveAs(result, 'dosagediary.pdf');
    }
  }

  function closePreview() {
    setPreviewUrl(null);
    setProfileName(null);
    setPreviewBlob(null);
  }

  return {
    handleDosageDiaryDownloadByProfile,
    previewUrl,
    profileName,
    previewBlob,
    closePreview,
    activeButtonIndex,
  };
}
